import {HttpErrorResponse} from "@angular/common/http";
import {Observable} from "rxjs";

export class DownloadFileUtil {
  static download(res) {
    const contentDisposition = res.headers.get('content-disposition');
    const filename = contentDisposition.split(';')[1].split('=')[1].trim().replace(/\"/g, '');
    let newBlob = new Blob([res.body]);
    // fix for IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob, filename);
      return;
    }
    const data = window.URL.createObjectURL(newBlob);
    const link = document.createElement('a');
    link.href = data;
    link.download = filename;
    link.click();
  }

  static parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();

    const obs = new Observable((observer: any) => {
      reader.onloadend = (e) => {
        observer.error(new HttpErrorResponse({
          ...err,
          error: JSON.parse(reader.result as string),
        }));
        observer.complete();
      };
    });
    reader.readAsText(err.error);
    return obs;
  }
}
